export default __webpack_public_path__ + "static/media/icone-local.135a2267.svg";